import { saveAs } from 'file-saver'

export { saveAs }

export function downloadBlob(blob: Blob, filename: string): void {
  saveAs(blob, filename)
}

export function downloadCsvString(csv: string, filename: string): void {
  const BOM = '\uFEFF'
  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8' })
  saveAs(blob, filename)
}

export function csvEscape(value: string | null | undefined): string {
  if (value == null) return ''
  const str = String(value)
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export function toCsvRow(values: (string | number | null | undefined)[]): string {
  return values.map((v) => csvEscape(v == null ? '' : String(v))).join(',')
}

export function toCsvString(headers: string[], rows: (string | number | null | undefined)[][]): string {
  const lines = [toCsvRow(headers), ...rows.map(toCsvRow)]
  return lines.join('\r\n')
}

// responseType:'blob' のダウンロード API がエラーを返すと error.response.data は Blob になる。
// （クライアントのインターセプタが JSON 本文を展開済みの場合はオブジェクトになっている）
// どちらの形でもバックエンドのエラーメッセージ（.message）を取り出す。失敗時は undefined。
export async function extractBlobErrorMessage(error: unknown): Promise<string | undefined> {
  if (typeof error !== 'object' || error === null) return undefined
  const data = (error as { response?: { data?: unknown } }).response?.data
  try {
    if (data instanceof Blob) {
      const text = await data.text()
      if (!text) return undefined
      const parsed = JSON.parse(text) as { message?: unknown }
      return typeof parsed.message === 'string' ? parsed.message : undefined
    }
    if (typeof data === 'object' && data !== null) {
      const message = (data as { message?: unknown }).message
      return typeof message === 'string' ? message : undefined
    }
  } catch {
    return undefined
  }
  return undefined
}
